/**
 * Vehicle Valuation Service API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { CaseFilesCommandHandlerResponse } from '../model/caseFilesCommandHandlerResponse';
import { CommandHandlerResponse } from '../model/commandHandlerResponse';
import { UpdateCaseImagesOrderCommand } from '../model/updateCaseImagesOrderCommand';
import { UpdateCasePromoImagesCommand } from '../model/updateCasePromoImagesCommand';
import { UpdateTwinnerImagesCommand } from '../model/updateTwinnerImagesCommand';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class CaseFilesService {

    protected basePath = 'https://localhost';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * AmsAction:POST/api/CaseFiles/AddDocument AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/case/{command.AggregateRootId} 
     * @param aggregateRootId 
     * @param file 
     * @param name If this is ommited, name is generated from the file name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addDocument(aggregateRootId?: string, file?: Blob, name?: string, observe?: 'body', reportProgress?: boolean): Observable<CaseFilesCommandHandlerResponse>;
    public addDocument(aggregateRootId?: string, file?: Blob, name?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CaseFilesCommandHandlerResponse>>;
    public addDocument(aggregateRootId?: string, file?: Blob, name?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CaseFilesCommandHandlerResponse>>;
    public addDocument(aggregateRootId?: string, file?: Blob, name?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any) };
        let useForm = true;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (aggregateRootId !== undefined) {
            formParams = formParams.append('AggregateRootId', <any>aggregateRootId) || formParams;
        }
        if (file !== undefined) {
            formParams = formParams.append('File', <any>file) || formParams;
        }
        if (name !== undefined) {
            formParams = formParams.append('Name', <any>name) || formParams;
        }

        return this.httpClient.post<CaseFilesCommandHandlerResponse>(`${this.basePath}/api/CaseFiles/AddDocument`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:POST/api/CaseFiles/AddImages AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/case/{command.AggregateRootId} 
     * @param aggregateRootId 
     * @param files 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addImages(aggregateRootId?: string, files?: Array<Blob>, observe?: 'body', reportProgress?: boolean): Observable<CaseFilesCommandHandlerResponse>;
    public addImages(aggregateRootId?: string, files?: Array<Blob>, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CaseFilesCommandHandlerResponse>>;
    public addImages(aggregateRootId?: string, files?: Array<Blob>, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CaseFilesCommandHandlerResponse>>;
    public addImages(aggregateRootId?: string, files?: Array<Blob>, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {



        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any) };
        let useForm = true;
        let convertFormParamsToString = false;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (aggregateRootId !== undefined) {
            formParams = formParams.append('AggregateRootId', <any>aggregateRootId) || formParams;
        }
        if (files) {
            files.forEach((element) => {
                formParams = formParams.append('Files', <any>element) || formParams;
            })
        }

        return this.httpClient.post<CaseFilesCommandHandlerResponse>(`${this.basePath}/api/CaseFiles/AddImages`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:DELETE/api/CaseFiles/DeleteDocument/{caseId}/{documentKey} AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/case/{caseId} 
     * @param caseId 
     * @param documentKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteDocuments(caseId: string, documentKey: string, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public deleteDocuments(caseId: string, documentKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public deleteDocuments(caseId: string, documentKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public deleteDocuments(caseId: string, documentKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling deleteDocuments.');
        }

        if (documentKey === null || documentKey === undefined) {
            throw new Error('Required parameter documentKey was null or undefined when calling deleteDocuments.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<CommandHandlerResponse>(`${this.basePath}/api/CaseFiles/DeleteDocument/${encodeURIComponent(String(caseId))}/${encodeURIComponent(String(documentKey))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:DELETE/api/CaseFiles/DeleteImage/{caseId}/{imageKey} AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/case/{caseId} 
     * @param caseId 
     * @param imageKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteImage(caseId: string, imageKey: string, observe?: 'body', reportProgress?: boolean): Observable<CommandHandlerResponse>;
    public deleteImage(caseId: string, imageKey: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CommandHandlerResponse>>;
    public deleteImage(caseId: string, imageKey: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CommandHandlerResponse>>;
    public deleteImage(caseId: string, imageKey: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (caseId === null || caseId === undefined) {
            throw new Error('Required parameter caseId was null or undefined when calling deleteImage.');
        }

        if (imageKey === null || imageKey === undefined) {
            throw new Error('Required parameter imageKey was null or undefined when calling deleteImage.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete<CommandHandlerResponse>(`${this.basePath}/api/CaseFiles/DeleteImage/${encodeURIComponent(String(caseId))}/${encodeURIComponent(String(imageKey))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:PUT/api/CaseFiles/ReplaceImage AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/case/{command.AggregateRootId} 
     * @param aggregateRootId 
     * @param image 
     * @param originalFileKey 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public replaceImage(aggregateRootId?: string, image?: Blob, originalFileKey?: string, observe?: 'body', reportProgress?: boolean): Observable<CaseFilesCommandHandlerResponse>;
    public replaceImage(aggregateRootId?: string, image?: Blob, originalFileKey?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CaseFilesCommandHandlerResponse>>;
    public replaceImage(aggregateRootId?: string, image?: Blob, originalFileKey?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CaseFilesCommandHandlerResponse>>;
    public replaceImage(aggregateRootId?: string, image?: Blob, originalFileKey?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'multipart/form-data'
        ];

        const canConsumeForm = this.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any) };
        let useForm = true;
        let convertFormParamsToString = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        // see https://stackoverflow.com/questions/4007969/application-x-www-form-urlencoded-or-multipart-form-data
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        }

        if (aggregateRootId !== undefined) {
            formParams = formParams.append('AggregateRootId', <any>aggregateRootId) || formParams;
        }
        if (image !== undefined) {
            formParams = formParams.append('Image', <any>image) || formParams;
        }
        if (originalFileKey !== undefined) {
            formParams = formParams.append('OriginalFileKey', <any>originalFileKey) || formParams;
        }

        return this.httpClient.put<CaseFilesCommandHandlerResponse>(`${this.basePath}/api/CaseFiles/ReplaceImage`,
            convertFormParamsToString ? formParams.toString() : formParams,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:PUT/api/CaseFiles/UpdateImagesOrder AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/case/{command.AggregateRootId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateImagesOrder(body?: UpdateCaseImagesOrderCommand, observe?: 'body', reportProgress?: boolean): Observable<CaseFilesCommandHandlerResponse>;
    public updateImagesOrder(body?: UpdateCaseImagesOrderCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CaseFilesCommandHandlerResponse>>;
    public updateImagesOrder(body?: UpdateCaseImagesOrderCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CaseFilesCommandHandlerResponse>>;
    public updateImagesOrder(body?: UpdateCaseImagesOrderCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.put<CaseFilesCommandHandlerResponse>(`${this.basePath}/api/CaseFiles/UpdateImagesOrder`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:POST/api/CaseFiles/UpdatePromoImages AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/case/{command.AggregateRootId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePromoImages(body?: UpdateCasePromoImagesCommand, observe?: 'body', reportProgress?: boolean): Observable<CaseFilesCommandHandlerResponse>;
    public updatePromoImages(body?: UpdateCasePromoImagesCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CaseFilesCommandHandlerResponse>>;
    public updatePromoImages(body?: UpdateCasePromoImagesCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CaseFilesCommandHandlerResponse>>;
    public updatePromoImages(body?: UpdateCasePromoImagesCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CaseFilesCommandHandlerResponse>(`${this.basePath}/api/CaseFiles/UpdatePromoImages`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:POST/api/CaseFiles/UpdateTwinnerImages AmsOptionalAction:SeeValuationsOfOthersUsers AmsResource:{country}/{business}/case/{command.AggregateRootId} 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTwinnerImages(body?: UpdateTwinnerImagesCommand, observe?: 'body', reportProgress?: boolean): Observable<CaseFilesCommandHandlerResponse>;
    public updateTwinnerImages(body?: UpdateTwinnerImagesCommand, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<CaseFilesCommandHandlerResponse>>;
    public updateTwinnerImages(body?: UpdateTwinnerImagesCommand, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<CaseFilesCommandHandlerResponse>>;
    public updateTwinnerImages(body?: UpdateTwinnerImagesCommand, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<CaseFilesCommandHandlerResponse>(`${this.basePath}/api/CaseFiles/UpdateTwinnerImages`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
